// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f840ba8","239":"fcaddd2b","455":"b229ddfe"}[chunkId] + ".chunk.js";
};